import { URL_API } from "../constants/urls";

export const BASE_URL_WS = URL_API;

export const LOGIN = "/api/users/login";
export const LOGOUT = "/api/users/doLogout";

//paciente
export const PACIENTE_LIST = "api/patient/allpaginable";
export const PACIENTES_ADD = "api/patient/addPatient";
export const PACIENTES_EDIT = "api/patient";
export const PACIENTE_BY_EMAIL = "/api/patient/findbyemail";
export const PACIENTE_UPDATE = "/api/patient/update";
export const PACIENTE_BY_ID = "/api/patient";
export const PACIENTE_UNIFICAR = "/api/patient/unificar";
export const PACIENTE_BUSCAR = "/api/patient/buscarPaciente";

//doctor
export const DOCTOR_LIST = "api/doctor/allpaginable";
export const DOCTOR_ADD = "api/doctor/addDoctor";
export const DOCTOR_UPDATE = "api/doctor/update";
export const DOCTOR_GET = "api/doctor/findDoctorDTO";
export const DOCTOR_BY_EMAIL = "api/doctor/findbyemail";
export const DOCTORS_BY_SPECIALITY = "api/doctor_specialty/list_specialty";
export const DOCTORS_BY_ID = "/api/doctor/findDoctorDTO";
export const DOCTOR_NOTIFICACIONES = "/api/notification/list_doctor";
export const DOCTOR_MY_APPOINTMENT = "/api/appointment/show_by_doctor";
export const DOCTOR_APPOINTMENT_BY_DATE = "/api/appointment/list";
export const DOCTOR_APPOINTMENT_BY_PATIENT =
  "/api/appointment/appointments_doctor_patient";
export const DOCTOR_SCHEDULES_BY_DATES = "/api/schedule/list_by_doctor_range";
export const DOCTOR_GET_BY_SPECIALITY = "/api/doctor_specialty/list_specialty";

//especialidades
export const ESPECIALITIES_LIST = "api/specialty/allpaginable/0/999/id/asc";
export const ESPECIALITIES_ADD = "api/specialty/save";
export const ESPECIALITIES_ALL = "api/specialty/list_all";
export const ESPECIALITIES_ALL_BY_ACCOUNT = "api/specialty/list_by_account";
export const ESPECIALITIES_GET = "api/specialty";
export const ESPECIALITIES_DELETE = "api/specialty/delete";
export const ESPECIALITIES_UDPDATE = "/api/specialty/update";

//modalidades
// export const CONSULTORIO_MODALIDADES = "/api/modalidadatencion/catalogo/1";
// export const VIDEOCONSULTA_MODALIDADES = "/api/modalidadatencion/catalogo/2";

//religion
export const RELIGIONES_ALL = "api/religion/allpaginable/0/999/id/asc";
export const RELIGIONES_LIST = "api/religion/allpaginable";
export const RELIGIONES_ADD = "api/religion/save";
export const RELIGIONES_UPDATE = "/api/religion/update";
export const RELIGIONES_GET = "api/religion";
export const RELIGIONES_DELETE = "api/religion/delete";
export const RELIGIONES_ACTIVE_ALL = "/api/religion/list_active";

//pais
export const COUNTRY_ALL = "api/country/allpaginable/0/999/id/asc";
export const COUNTRY_LIST = "api/country/allpaginable";
export const COUNTRY_ADD = "api/country/save";
export const COUNTRY_GET = "api/country";
export const COUNTRY_DELETE = "api/country/delete";
export const COUNTRY_ACTIVE_ALL = "/api/country/list_active";
export const COUNTRY_UPDATE = "/api/country/update";

//lenguage
export const LANGUAGE_ALL = "api/language/allpaginable/0/999/id/asc";
export const LANGUAGE_LIST = "api/language/allpaginable";
export const LANGUAGE_ADD = "api/language/save";
export const LANGUAGE_UPDATE = "api/language/update";
export const LANGUAGE_GET = "api/language";
export const LANGUAGE_DELETE = "api/language/delete";
export const LANGUAGE_ACTIVE_ALL = "/api/language/list_active";

//acount
export const ACCOUNT_ALL = "/api/account/allpaginable/0/999/id/asc";
export const ACCOUNT_LIST = "api/account/allpaginable";
export const ACCOUNT_ADD = "api/account/save";
export const ACCOUNT_GET = "api/account";
export const ACCOUNT_DELETE = "api/account/delete";
export const ACCOUNT_ACTIVE_ALL = "/api/account/list_active";

//compnay
export const COMPANY_ALL = "/api/company/allpaginable/0/999/id/asc";
export const COMPANY_LIST = "api/company/allpaginable";
export const COMPANY_ADD = "api/company/save";
export const COMPANY_GET = "api/company";
export const COMPANY_DELETE = "api/company/delete";
export const COMPANY_ALL_ACTIVE = "/api/company/list_active";

//marital estatus
export const MARITAL_STATUS_ALL =
  "/api/maritalstatus/allpaginable/0/999/id/asc";
export const MARITAL_STATUS_ACTIVE_ALL = "/api/maritalstatus/list_active";
export const MARITAL_STATUS_ADD = "/api/maritalstatus/save";
export const MARITAL_STATUS_UPDATE = "/api/maritalstatus/update";

//horarios
export const SCHEDULE_BY_SPECIALITY = "/api/schedule/list_by_specialty";
export const SCHEDULE_APPOINTMENT = "/api/schedule/list_by_doctor";
export const SCHEDULE_ADD = "/api/schedule/addScheduleBatchNew";
export const SCHEDULE_LIST_BY_DATES = "/api/schedule/list_by_dates";

//hour settings
export const HOUR_SETTINGS_ALL = "api/hour_settings/list_active";
export const HOUR_SETTINGS_LIST = "api/hour_settings/allpaginable";
export const HOUR_SETTINGS_ADD = "api/hour_settings/save";
export const HOUR_SETTINGS_GET = "api/hour_settings";

//doctor por especialidad
export const DOCTOR_BY_SPECIALITY_HOUR = "/api/schedule/list_by_specialty";

//agendar cita
export const ADD_APPOINTMENT = "/api/appointment/addAppointment";
export const UPDATE_APPOINTMENT = "/api/appointment/update";

//citas del paciente por fecha y cantidad
export const MY_APPOINTMENT = "/api/appointment/show_by_patient";

//Hours
export const HOURS_DAY = "/api/hour/list";

//citas
export const GET_APPOINTMENT_BY_ID = "/api/appointment";

//horarios del doctor
export const GET_HOUR_BY_DOCTOR_DAYS =
  "/api/doctor_specialty/list_doctor_schedules";

//docuemnto
export const DOCUMENT_GET_BY_APPOINTMENT = "/api/document/findByAppointment";
export const DOCUMENT_ADD_BY_APPOINTMENT = "/api/document/addDocument";
export const DOCUMENT_DELETE = "/api/document/delete";

//historia medica
export const MEDICAL_HISTORY_GET_BY_ID =
  "/api/medicalHistory/findMedicalHistory";
export const MEDICAL_HISTORY_ADD = "/api/medicalHistory/saveMedicalHistory";
export const MEDICAL_HISTORY_UPDATE = "/api/medicalHistory/update";
export const MEDICAL_HISTORY = "/api/medicalHistory/viewMedicalHistory";
export const FICHA_EPIDEMIOLOGICA_GET_BY_APPOINTMENT =
  "/api/medicalHistory/viewEpidemiologicalFile";
export const FICHA_EPIDEMIOLOGICA_SAVE =
  "/api/medicalHistory/saveEpidemiologicalFile";
export const FICHA_EPIDEMIOLOGICA_GET_BY_ID =
  "/api/medicalHistory/findEpidemiologicalFile";
export const FICHA_EPIDEMIOLOGICA_UPDATE =
  "/api/medicalHistory/updateEpidemiologicalFIle";
export const GET_INCAPACIDADES = "/api/medicalHistory/verincapacidades";

//appointment doctor
export const APPOINTMENT_BY_DOCTOR = "/api/appointment/show_by_doctor";
export const GET_APPOINTMENTS_HISTORICAL =
  "/api/appointment/appointments_doctor_patient";
export const APPOINTMENT_PATIENT = "/api/appointment/patient";

//eliminar cita
export const APPOINTMENT_CANCEL = "/api/appointment/cancel";
export const APPOINTMENTS_BY_DOCTOR = "/api/appointment/list_patient_by_doctor";
export const APPOINTMENT_UPDATE = "/api/appointment/update";
export const APPOINTMENT_UPDATE_ONDEMAND = "/api/appointment/updateOndemand";

//encuesta
export const SURVEY_GET = "/api/survey/show";

//respuesra de ecnuesta
export const SURVEY_ANSWER_SAVE = "/api/surveyanswer/save_survey";

//procesar pago appointment conketa
export const PAYMENT_APPOINTMENT_CONEKTA = "/api/appointment/charges";

//docotres de paciente
export const DOCTORS_BY_PATIENT_ID = "/api/appointment/list_doctor_by_patient";

//notificaciones_paciente
export const NOTIFICACIONE_PACIENTE = "/api/notification/list_patient";

//Recet
export const RECETA_GET = "/api/receta/get";
export const RECETA_SAVE = "/api/receta/save";

//Disease
export const DISEASE_GET_ALL = "/api/disease/allpaginable/0/20000/id/asc";
export const DISEASE_GET_ALL_NEW = "/api/disease/paginable";
export const DISEASE_SAVE = "api/disease/save";

//Currency
//cita de emergecnia
export const APPOINTMENT_ON_DEMAND = "/api/appointment/on_demand";

//currency
export const CURRENCY_LIST_ACTIVE = "/api/currency/list_active";

//paymene sin cobertura
export const APPOINTMENT_SIN_COBERTURA_PAYMENT =
  "/api/appointment/payment_ondemand";

//Provider
export const PROVIDER_LIST_ACTIVE = "/api/provider/list_active";
export const PROVIDER_ALL = "/api/provider/allpaginable/0/999/id/asc";
export const PROVIDER_ADD = "/api/provider/save";
export const PROVIDER_UPDATE = "/api/provider/update";

//correos
export const CORREOS_LIST = "/api/email_template/allpaginable/0/999/id/asc";
export const CORREOS_SAVE = "/api/email_template/save";
export const CORREOS_GET_BY_ID = "/api/email_template";
export const CORREOS_DELETE = "/api/email_template/delete";

//appointment dmand 'link'
export const APPOINTMENT_DEMAND_LINK = "/api/appointment/on_demand_account";
export const APPOINTMENT_PUBLIC = "/api/appointment/public";

//pendientes operador
export const APPOINTMENT_ONLY_PENDING = "/api/appointment/list_by_status";

//servciiso sin token
export const GET_PATIENT_SIN_TOKEN = "/api/patient/public";
export const GET_SPECIALITY_SIN_TOKEN = "/api/specialty/public/list_active";
export const GET_DOCTOR_BY_SPECIALITY_SIN_TOKEN =
  "/api/doctor_specialty/public/list_specialty";
export const GET_HOURS_BY_DOCTOR_SIN_TOKEN =
  "/api/doctor_specialty/public/list_doctor_schedules";
export const SAVE_APPOINTMENT_SIN_TOKEN =
  "/api/appointment/public/addAppointment";
export const UPDATE_PATIENT_BY_IDAPP_IDPAT =
  "/api/appointment/check_appointment";
export const CHECK_PATIENT_BY_EMAIL = "/api/appointment/check_patient";
export const GET_LINK_PATIENT_AUTOAGENDAMIENTO = "/api/linkpatient";
export const SAVE_LINK_PATIENT_AUTOAGENDAMIENTO = "/api/linkpatient/save";
export const SURVEY_SAVE_SIN_TOKEN = "/api/surveyanswer/public/save_survey";
export const GET_SURVEY_SIN_TOKEN = "/api/survey/public/show";
export const GET_ACCOUNT_SIN_TOKEN = "/api/account/public";
export const UPDATE_APPOINTMENT_SIN_TOKEN = "/api/appointment/public/update";
export const GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN =
  "/api/specialty/public/list_by_account";
export const DOCUMENT_GET_BY_APPOINTMENT_SIN_TOKEN =
  "/api/document/public/findByAppointment";
export const DOCUMENT_ADD_BY_APPOINTMENT_SIN_TOKEN =
  "/api/document/public/addDocument";
export const DOCUMENT_DELETE_SIN_TOKEN = "/api/document/public/delete";
export const GET_DOCTOR_BY_SPECIALITY_ACCOUNT_SIN_TOKEN =
  "/api/doctor_specialty/public/list_specialty";
export const PARTNER_GET_ACTIVE_SIN_TOKEN =
  "/api/patientrelationship/public/list_active_by_account";

//partner
export const PARTNER_GET_ACTIVE = "/api/partner/list_active";

//Parther
export const PARTNER_LIST_ACTIVE = "/api/partner/list_active";
export const PARTNER_ALL = "/api/partner/allpaginable/0/999/id/asc";
export const PARTNER_ADD = "/api/partner/save";

export const HOURS_DAY_DOCTOR = "/api/hour/list_by_doctor";

//usuarios
export const GET_USUARIOS_ALL = "/api/users/list";
export const DELETE_USUARIO = "/api/users/delete";
export const USUARIOS_GET_BY_ID = "/api/users";
export const USUARIOS_SAVE = "/api/users/save";

//municipio
export const MUNICIPIO_LIST = "/api/municipio/list_active";
export const MUNICIPIO_ALL = "/api/municipio/allpaginable/0/9999/id/asc";
export const MUNICIPIO_ADD = "/api/municipio/save";
export const MUNICIPIO_UPDATE = "/api/municipio/update";

//STATES
export const STATES_LIST = "/api/state/list_active";
export const STATES_ALL = "/api/state/allpaginable/0/9999/id/asc";
export const STATES_ADD = "/api/state/save";
export const STATES_UPDATE = "/api/state/update";

//KPIS
export const GET_CITAS_BY_MONTH = "/api/kpis/findByMonthYear";

//reportes
export const REPORT_APPOINTMENTONLINEACCOUNT =
  "/api/kpis/appointmentsOnLineAccount";
export const REPORT_APPOINTMENTONLINESPECIALITY =
  "/api/kpis/appointmentsOnLineSpeciality";
export const REPORT_APPOINTMENTONLINEDOCTOR =
  "/api/kpis/appointmentsOnLineDoctor";
export const REPORT_APPOINTMENTONLINEPROVIDERSERVICE =
  "/api/kpis/appointmentsOnLineProviderService";
export const REPORT_APPOINTMENTONLINEDOCTORAVERAGE =
  "/api/kpis/appointmentsOnLineDoctorAverage";
export const REPORT_APPOINTMENTAVAILABILITY = "/api/kpis/availability";
export const REPORT_APPOINTMENTBYRANGE = "/api/kpis/appointmentDurationByRange";
export const REPORT_APPOINTMENTONDEMAND = "/api/kpis/request_demand";

//server time
export const GET_SERVER_TIME = "/api/kpis/serverHour";

//check doble factor de autenticacion
export const CHECK_CODE_VERIFICACION = "/api/users/public/checkAuth";
export const RESEND_CODE_VERIFICACION = "/api/users/public/resendToken";

//tipo documento paciente colombia
export const TIPO_DOCUMENTO_PACIENTE_COLOMBIA =
  "/api/patient/public/list_type_document";

//get tipo de diagnosticos
export const TIPO_DIAGNOSTICO_ALL_ACTIVE = "/api/disease/list_disease_type";
export const TIPO_DIAGNOSTICO_DELETE = "/api/disease/delete_disease";

//eliminar remisiones
export const REMISION_DELETE = "/api/disease/delete_remisiones";
export const ESTUDIO_IMAGEN_DELETE = "/api/disease/delete_estudios";
export const LABORATORIO_DELETE = "/api/disease/delete_laboratorio";

// catálogos para Remisiones, Imagenología y Laboratorios (paginado: page/size/sortDir/sortField/commonOrSearch/searchText)
// Default (más comunes): .../true/%20  |  Búsqueda: .../false/{texto con espacios como %20}
export const CATALOGO_REMISIONES_BASE = "/api/catalogo-remisiones/0/10/id/asc";
export const CATALOGO_IMAGENOLOGIA_BASE = "/api/catalogo-imagenologia/0/10/id/asc";
export const CATALOGO_LABORATORIOS_BASE = "/api/catalogo-laboratorios/0/10/id/asc";

//trazabilidad
export const TRAZABILIDAD_LIST = "/api/appointment/traceabilityPage";
export const DOCUMENT_GET_BY_APPOINTMENTPUBLIC =
  "/api/document/public/findByAppointment";
export const CHAT_GET_BY_TOKENID = "/api/chat/findByToken";
export const RECORDING_GET_BY_APPOINTMENT =
  "/api/document/recordingsByAppointment";

//relacion con pacientes
export const PACIENTERELACION_GET_ALL =
  "/api/patientrelationship/allpaginable/0/999/id/asc";
export const PACIENTERELACION_GET_ACTIVE =
  "/api/patientrelationship/list_active}";
export const PACIENTERELACION_SAVE = "/api/patientrelationship/save";
export const PACIENTERELACION_UPDATE = "/api/patientrelationship/update";

//reporte citas pendientes
export const REPORTE_CITAS_PENDIENTE = "/api/appointment/historicPage";

//aprobar o no aprobar pendientes
export const PENDIENTES_CANCELAR = "/api/appointment/cancelHistoric";
export const PENDIENTES_UPDATE = "/api/appointment/updateHistoric";

//schedule of doctors
export const DOCTOR_CREATE_SCHEDULE = "/api/schedule/addScheduleNew";
export const DOCTOR_GET_SCHEDULE = "/api/schedule/doctor";
export const DOCTOR_DINAMIC_SCHEDULE =
  "/api/schedule/createDynamicScheduleByDoctor";
export const SCHEDULE_DINAMIC_BY_SPECIALITY =
  "/api/schedule/createDynamicScheduleBySpeciality";

//trazabilidad notifications
export const NOTIFICACIONES_BY_APPOINTMENT =
  "/api/notification/find_by_appointment";

//extender tiempo de consulta
export const APPOINTMENT_EXTEND_TIME = "/api/appointment/extendTime";

//reporte citas reasignada
export const REPORTE_CITA_REASIGNADA = "/api/notification/findAllByType";

//expediente clinico
export const GET_TIPO_FAILIAR = "/api/medicalHistoryMx/list_tipo_familiar";
export const GET_MASCOTAS = "/api/medicalHistoryMx/list_mascota";
export const GET_FAMILIAR = "/api/medicalHistoryMx/list_familiar";
export const GET_EFERMEDADES = "/api/medicalHistoryMx/list_enfermedad";
export const SAVE_EXPEDIENTE_CLINICO = "/api/medicalHistoryMx/save";
export const GET_EXPEDIENTE_CLINICO_BY_APPOINTMENT =
  "/api/medicalHistoryMx/find_by_appointment";
export const UPDATE_EXPEDIENTE_CLINICO = "/api/medicalHistoryMx/update";
export const GET_CHECKLIST_DOCUMENTS =
  "/api/medicalHistory/checklistdocumentos";
export const GET_CHECKLIST_DOCUMENTS_ADJUNTOS =
  "/api/medicalHistory/checklistdocumentosadjuntos";

//reporte expediente clinico
export const REPORT_HISTORIC_DATA = "/api/medicalHistoryMx/historic_data";
export const RESPORT_HISTORIC_EXP =
  "/api/medicalHistoryMx/historic_appointment";
export const REPORT_DOCUMENT_PATIENT = "/api/document/document_patient";
export const REPORT_MEDICAMENTOS = "/api/receta/medicamento_patient";

export const ROLE_LIST = "/role/";
export const UPDATE_ROLE = "/role/update";

export const GET_SURVEY_BY_APPOINTMENT = "/api/surveyanswer/show";

//control notification
export const CONTROL_NOTIFICATION = "/api/notification/allPageableByType";

//send surveyexternna
export const SEND_SURVEY_EXTERNA = "/api/notification/sendSurvey";

//sucursales
export const GET_SUCURSALES = "/api/branch_office/";

//para la direccion nueva de colombia
export const GET_ROAD_TYPE = "/api/common/listRoadTypes";
export const GET_PROPERTY_TYPES = "/api/common/listPropertyTypes";

//loclidad
export const GET_LOCALIDADES = "/api/municipio/list_localidad";

//ocupacion
export const GET_OCUPACION = "/api/common/listOcupation";

//eps
export const GET_EPS = "/api/common/listEps";

//check reasignacion de cita
export const CHECK_CITA_REASIGNED = "/api/appointment/validateReassigned";

//get espcialidad eps
export const GET_ESPECIALIDAD_EPS = "/api/specialty/public/list_by_account";

//validar nueva eps
export const VALIDATE_NUEVA_EPS = "/api/patient/validarNuevaEps";

//salvar file en correo
export const UPLOAD_FILE_CORREO = "/api/document/saveEmailDocument";
export const DELETE_FILE_CORREO = "/api/document/deleteEmailDocument";

//planes
export const GET_PLANES = "/api/account/list_plan_cuenta";
export const TIPOPLAN_ADD = "api/plan/save";
export const TIPOPLAN_UPDATE = "api/plan/update";
export const GET_TIPOPLAN_ALL = "api/plan/list";

//check link
export const CHECK_LINK = "api/linkpatient/surl";

//acount configuracion fields
export const ACCOUNT_SETTING_GET_BY_ID = "/api/accountformsettings/account";
export const FIELDS_GET = "api/formsettings";
export const ACCOUNT_SETTING_SAVE = "/api/accountformsettings/save";
export const ACCOUNT_SETTING_UPDATE = "/api/accountformsettings/update";

//resend notificacion
export const APPOINTMENT_RESEND_NOTIFICACION = "/api/appointment";

//account configuration messages
export const ACCOUNT_CONF_MESSAGES_GET_BY_ID = "/api/accountformtext/account";
export const ACCOUNT_CONF_MESSAGES_SAVE = "/api/accountformtext/save";
export const ACCOUNT_CONF_MESSAGES_UPDATE = "/api/accountformtext/update";

//consultar consentimiento informado
export const GET_CONSENTIMIENTO_INFORMADO = "/api/appointment/informedConsent";

//consultar consentimiento informado cosnultorio
export const GET_CONSENTIMIENTO_INFORMADO_CONSULTORIO =
  "/api/appointment/informedConsentOffice";

//Generic text cita
export const GET_GENERIC_TEXT = "/api/generic_text";

export const VALIDATE_QUALITAS = "/api/patient/validarqualitas";

//encuesta
export const ENCUESTA_ALL = "/api/survey/allpaginable/0/999/id/asc";
export const ENCUESTA_GET = "/api/survey";
export const ENCUESTA_ADD = "/api/survey/save";
export const ENCUESTA_GET_CLIENT = "/api/survey/show";

//historia medica
export const MEDICAL_HISTORY_MX_GET_BY_ID =
  "/api/medicalHistoryMx/find-medical-record";
export const MEDICAL_HISTORY_MX_ADD =
  "/api/medicalHistoryMx/save-medical-record/";
export const MEDICAL_HISTORY_MX_UPDATE =
  "/api/medicalHistoryMx/update-medical-record/";

// obstetrico
export const MEDICAL_HISTORY_MX = "/api/medicalHistoryMx";

//expediente duplication check
export const CHECK_EXPEDIENTE_DUPLICADO = "/api/appointment/existe-expediente";